import { AxiosError } from 'axios'
import { flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { searchQueryConfig } from 'Core/constants/filters'
import { CoreUrlParams, RequestDataAdditionalParams, SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'

import { UrlParams } from 'Portals/Supplier/constants'
import { Invoice } from 'Portals/Supplier/entities'
import {
	getFilterConfig,
	getMainSearchConfig
} from 'Portals/Supplier/Pages/Invoice/TableList/Filters/utils'
import { InvoiceRepo } from 'Portals/Supplier/repositories'
import { RootStore } from 'Portals/Supplier/stores'

const STORAGE_PAYMENT_PAGE_SIZE = 'is2/invoicePageSize'

export class InvoiceTable extends TableStore<Invoice.Basic> {
	constructor(public rootStore: RootStore) {
		super(STORAGE_PAYMENT_PAGE_SIZE)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams, params?: RequestDataAdditionalParams) {
		if (!params) {
			return
		}
		const { loadPage, calculateCount } = params

		try {
			yield this.requestData({
				defaultSort,
				repository: InvoiceRepo.getList,
				additionalParams: { loadPage, calculateCount },
				withoutURLParams: !loadPage,
				isToCallCount: calculateCount,
				isSplittedAPI: true
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	initFromURLParams = (params: Record<string, string[]>) => {
		const searchKeys = [UrlParams.supplierInvoiceNumber, CoreUrlParams.searchQuery]

		const filterKeys = [
			UrlParams.startDate,
			UrlParams.endDate,
			UrlParams.supplierLocationId,
			UrlParams.status
		]

		const mergedSearchConfig = {
			...getMainSearchConfig(),
			...searchQueryConfig
		}

		this.initSearchParamsFromUrl(params, searchKeys, mergedSearchConfig)
		this.initFilterParamsFromUrl(params, filterKeys, getFilterConfig())
	}

	reset = () => {
		this.resetTable()
	}
}
